/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_DismissInputs */

const en_whats_new_dismiss = /** @type {(inputs: Whats_New_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Got it`)
};

const de_whats_new_dismiss = /** @type {(inputs: Whats_New_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verstanden`)
};

/**
* | output |
* | --- |
* | "Got it" |
*
* @param {Whats_New_DismissInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const whats_new_dismiss = /** @type {((inputs?: Whats_New_DismissInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_DismissInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_whats_new_dismiss(inputs)
	return en_whats_new_dismiss(inputs)
});